import { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import AuthOutlet from '@auth-kit/react-router/AuthOutlet';
import EmptyData from '../EmptyData';
import Container from './Container';
import Content from './Main';

const MainLayout = () => {
    // Default terbuka di desktop (>= 768px), tertutup di mobile (< 768px) agar konten lebar penuh
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
    const location = useLocation();

    const from = location.pathname !== '/'
        ? `?${new URLSearchParams({ from: `${location.pathname}` }).toString()}`
        : '';

    // Otomatis tutup sidebar saat pindah route di mobile
    useEffect(() => {
        if (window.innerWidth < 768) {
            setIsSidebarOpen(false);
        }
    }, [location.pathname]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="flex flex-col h-screen bg-gray-100">
            <div className="flex flex-1 overflow-hidden relative">
                {/* Backdrop overlay di mobile ketika sidebar terbuka */}
                {isSidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black/40 backdrop-blur-xs z-40 md:hidden transition-opacity"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                <Container>
                    <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                    <Content>
                        <ErrorBoundary fallback={<EmptyData />}>
                            <AuthOutlet fallbackPath={`/login${from}`} />
                        </ErrorBoundary>
                    </Content>
                </Container>
            </div>
        </div>
    );
};

export default MainLayout;
